import React from 'react';
import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';

// RowPerPage receives current rowsPerPage and a callback for changes
// Uses custom arrow icon from /public/images/ep_arrow-down.png
const RowPerPage = ({ rowsPerPage, onRowsChange, options = [5, 8, 10, 20, 50, 100] }) => {
    const handleChange = (e) => {
        onRowsChange(parseInt(e.target.value, 10));
    };

    return (
        <Box display="flex" alignItems="center" gap={0} sx={{ mt: -0 }}>
            <Typography color="text.secondary" variant="body2">
                Rows per page:
            </Typography>
            <FormControl size="small">
                <Select
                
                    value={rowsPerPage}
                    onChange={handleChange}
                    variant="outlined"
                    IconComponent={(iconProps) => (
                        <img
                        
                            {...iconProps}
                            src="/images/ep_arrow-down.png"
                            alt="arrow down"
                            style={{
                            
                                // first, preserve any styles MUI has passed:
                                ...iconProps.style,
                                // then override with your desired size & fit:
                                width: 50,
                                height: 20,
                              

                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    )}
                    sx={{
                        
                        minWidth: 80,
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderWidth: 0,
                        },
                        color: 'text.secondary',
                    }}
                >
                    {options.map((n) => (
                        <MenuItem key={n} value={n}>
                            {n}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default RowPerPage;